import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Router, NavigationEnd} from '@angular/router';
import {filter} from 'rxjs/operators';
import {HistoryEntry} from '../models/history-entry.model';
import {fuseNavigation} from '../../fuse-navigation';
import {FuseNavigation} from '../../../@fuse/types';

@Injectable({
  providedIn: 'root'
})
export class RouterHistoryService {
  previousUrls$ = new BehaviorSubject<HistoryEntry[]>(null);
  currentUrl$ = new BehaviorSubject<HistoryEntry>(null);

  private _history: HistoryEntry[] = [];

  private getChildren(fromEntry: FuseNavigation) {
    const children = [];
    fromEntry.children.forEach(entryChild => {
      if (entryChild.children != null && entryChild.children.length > 0) {
        entryChild.children.forEach(nestedChild => {
          if (nestedChild.url) {
            children.push({
              url: nestedChild.url,
              icon: nestedChild.icon,
              title: nestedChild.title,
              type: 'item'
            });
          }
        });
      }

      if (entryChild.url !== null) {
        children.push({
          url: entryChild.url,
          icon: entryChild.icon,
          title: entryChild.title,
          type: 'item'
        });
      }
    });

    return children;
  }

  private getInfoForRoute(route: string): HistoryEntry | null {
    const allChildren = [].concat(...fuseNavigation.map(entry => this.getChildren(entry)));
    const child = allChildren.find(child => child.url == route);

    if (child != null) {
      return child;
    }

    return null;
  }

  constructor(router: Router) {
    router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
      ).subscribe((event) => {
      const route = event['url'];
      let routeInfo: HistoryEntry = this.getInfoForRoute(route);

      if (!!!routeInfo) {
        routeInfo = this.getInfoForRoute(route.substring(0, route.lastIndexOf('/')));
      }

      const existingIndex = this._history.indexOf(routeInfo);

      if (!!routeInfo && existingIndex !== 0) {
        this._history = [...this._history.slice(-5), routeInfo];
        this.currentUrl$.next(routeInfo);
        this.previousUrls$.next(this._history);
      }
    });
  }
}
